import type React from 'react';

export interface ChevronLeftIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	stroke?: string;
	strokeWidth?: string | number;
	'aria-label'?: string;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({
	width = 9,
	height = 14,
	fill = 'none',
	stroke = 'currentColor',
	strokeWidth = 2,
	'aria-label': ariaLabel = 'Chevron Left Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 9 14"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
	>
		<title>Arrow Left Icon</title>
		<path
			d="M8 1L2 7L8 13"
			stroke={stroke}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
		/>
	</svg>
);

export default ChevronLeftIcon;
